var _defs, _defs2, _defs3, _defs4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgService4(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 3710 3710",
    style: {
      enableBackground: "new 0 0 3710 3710"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Background"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#FFFFFF"
    },
    width: 3710,
    height: 3710
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Illustration"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 3513.918,
    y1: 3709.5769,
    x2: 1536.0446,
    y2: 1604.0994
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_1_)"
    },
    d: "M2920.063,2864.868c-73.015,75.261-138.346,119.502-188.366,152.901 c-487.834,325.731-1045.482,231.848-1217.893,199.759c-278.164-51.772-512.972-88.295-714.715-270.561 c-458.42-414.164-436.123-1278.142-85.834-1813.339c41.534-63.459,391.292-581.909,950.147-654.964 c13.669-1.787,23.867-2.804,32.8-3.75c86.453-9.154,622.189-57.464,1059.028,308.52c62.531,52.389,163.162,146.884,256.48,291.006 C3352.922,1601.414,3354.003,2417.58,2920.063,2864.868z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91B3FA"
    },
    d: "M1339.891,1760.398c67.864-131.825,194.092-224.764,340.709-241.364l10.029-634.743 c0.086-5.421-4.316-9.887-9.738-9.828c-413.536,4.479-778.432,261.859-948.728,643.091c-2.477,5.546,0.263,12.051,5.941,14.208 L1339.891,1760.398z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7D97F4"
    },
    d: "M2157.037,2064.503c-8.487-0.229-16.086,5.177-18.622,13.281 c-7.101,22.695-20.08,66.237-22.206,71.745c-10.338,26.786-22.447,52.913-36.631,77.885 c-26.305,46.312-59.945,88.758-101.448,122.367c-105.189,85.181-256.403,101.006-382.531,58.848 c-3.595-1.202-7.158-2.494-10.708-3.821c-6.571-2.457-13.944,0.27-17.317,6.421l-318.03,579.982 c154.43,77.442,299.756,97.693,482.083,86.008c529.729-33.949,945.694-464.063,991.863-997.446L2157.037,2064.503z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91B3FA"
    },
    d: "M2157.037,2064.503c-34.48,211.654-190.899,377.031-403.453,384.249 c-59.798,2.031-131.144-11.861-183.595-33.106c-5.47-2.216-11.738,0.021-14.703,5.124l-326.895,562.351 c154.43,77.442,328.817,115.347,511.144,103.663c529.728-33.949,945.694-477.121,991.863-1010.503L2157.037,2064.503z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91B3FA"
    },
    d: "M1160.254,2894.332l316.514-567.702c2.241-4.02,1.29-9.037-2.231-12.002 c-97.443-82.059-175.345-192.084-175.345-334.759c0-35.188-15.603-86.406-8.455-119.422l-595.24-212.846 c-33.041,107.48-50.881,221.874-50.881,340.404c0,383.174,203.596,720.178,483.144,913.898 C1138.689,2909.476,1153.78,2905.944,1160.254,2894.332z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7D97F4"
    },
    d: "M1128.605,2878.201l328.004-560.679c4.167-7.123,2.733-16.205-3.464-21.655 c-94.091-82.755-153.953-207.152-153.953-347.506c0-35.188,3.8-69.494,10.948-102.51l-605.727-226.426 c-4.824-1.803-10.201,0.837-11.673,5.773c-31.275,104.827-48.123,216.11-48.123,331.299 C644.617,2348.992,838.55,2686.967,1128.605,2878.201z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000134970524703832571030000008600255473501985196_",
    gradientUnits: "userSpaceOnUse",
    x1: 974.3479,
    y1: 2568.9287,
    x2: 6957.5571,
    y2: -2960.1118
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4F52FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4042E2"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000134970524703832571030000008600255473501985196_)"
    },
    d: "M1796.638,1522.048 c187.75,31.403,333.343,189.493,358.006,387.05c1.319,10.566,10.043,18.643,20.685,19l908.072,30.432 c2.823-2.736,4.311-4.178,7.133-6.914C3087.757,1191.963,2543.047,541.144,1813.406,455L1796.638,1522.048z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 18.6823 1921.3135)",
    style: {
      fill: "#91B3FA"
    },
    cx: 2328.572,
    cy: 938.105,
    rx: 219.758,
    ry: 219.758
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 17.613 1920.0299)",
    style: {
      fill: "#FFFFFF"
    },
    cx: 2326.488,
    cy: 938.754,
    rx: 199.872,
    ry: 199.872
  }), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("ellipse", {
    id: "SVGID_00000128449628770571487380000010705811562458181530_",
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 16.8402 1921.2981)",
    cx: 2327.632,
    cy: 940.321,
    rx: 199.872,
    ry: 199.872
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000039823228455007243300000015098257590827670959_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000128449628770571487380000010705811562458181530_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000039823228455007243300000015098257590827670959_)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7D97F4"
    },
    d: "M2217.541,1134.987c3.145-14.617,5.635-24.184,5.635-24.184l-55.555-94.089 c0,0-17.984,18.204-28.763,97.508c-1.493,10.983,7.045,20.766,18.13,20.766H2217.541z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7D97F4"
    },
    d: "M2518.029,1113.907c-15.429-68.76-42.891-100.769-42.891-100.769l-34.769,115.19 c0,0,1.052,2.273,2.656,6.659h58.132C2512.233,1134.987,2520.454,1124.715,2518.029,1113.907z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7D97F4"
    },
    d: "M2217.113,1134.987c57.114,21.007,134.72,18.07,225.275,0 c2.126-8.771,5.009-18.209,8.855-29.068l23.895-92.81c-33.493-30.028-80.57-39.944-98.683-42.76 c-42.087-10.438-91.28-1.188-91.28-1.188c-66.698,4.654-117.554,47.455-117.554,47.455l41.328,94.051 C2212.212,1118.58,2214.936,1126.703,2217.113,1134.987z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000145040684584931622720000003065327237545751961_",
    gradientUnits: "userSpaceOnUse",
    x1: 2322.9553,
    y1: 871.0587,
    x2: 2335.2375,
    y2: 1060.9647
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#C4421B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#5C0E16"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000145040684584931622720000003065327237545751961_)"
    },
    d: "M2293.717,923.818l-1.421,46.877 c-0.14,4.636,2.735,8.812,7.109,10.355c11.985,4.228,36.798,10.656,60.312,2.236c4.743-1.699,7.599-6.555,6.866-11.54 l-7.048-47.928H2293.717z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000036955710548845501800000015462913957284542640_",
    gradientUnits: "userSpaceOnUse",
    x1: 2323.9397,
    y1: 970.2686,
    x2: 2339.7344,
    y2: 770.4642
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#C4421B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#5C0E16"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000036955710548845501800000015462913957284542640_)"
    },
    d: "M2276.356,845.114 c0,0,2.754,63.329,13.768,88.11c11.014,24.781,38.548,24.781,41.301,24.781c2.753,0,27.534-5.507,41.302-27.534 c13.767-22.028,19.274-93.617,19.274-93.617s-24.781-27.534-57.823-30.288 C2301.137,803.813,2276.356,831.347,2276.356,845.114z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000182530364869277029050000017904215759386638270_",
    gradientUnits: "userSpaceOnUse",
    x1: 2379.8293,
    y1: 974.6876,
    x2: 2395.6243,
    y2: 774.8815
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#C4421B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#5C0E16"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000182530364869277029050000017904215759386638270_)"
    },
    d: "M2379.983,867.974 c0,0,12.636-18.953,18.954-12.636c6.318,6.318-6.318,47.385-18.954,47.385 C2367.348,902.723,2379.983,867.974,2379.983,867.974z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000183248645425833488800000015536097235924709300_",
    gradientUnits: "userSpaceOnUse",
    x1: 2266.7639,
    y1: 965.7496,
    x2: 2282.5588,
    y2: 765.9434
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#C4421B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#5C0E16"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000183248645425833488800000015536097235924709300_)"
    },
    d: "M2285.215,871.133 c0,0-15.795-22.112-22.113-15.795c-6.318,6.318,9.477,47.385,22.113,47.385V871.133z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000005261487999828096250000004433028455338305716_",
    gradientUnits: "userSpaceOnUse",
    x1: 2325.1697,
    y1: 778.4229,
    x2: 2350.8181,
    y2: 976.821
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#090056"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#020039"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000005261487999828096250000004433028455338305716_)"
    },
    d: "M2399.804,829.605 c0.076-4.284-0.165-8.711-0.383-13.761c-0.217-5.045,0.252-10.092,0.79-15.113c1.552-14.477-13.557-25.939-27.234-22.307 c-1.054,0.28-2.188,0.636-3.204,0.239c-1.269-0.496-1.828-1.94-2.335-3.205c-3.16-7.881-11.567-18.066-19.525-21.399 c-6.842-2.865-14.402-4.063-21.784-3.218c-14.867,1.702-28.526,11.624-34.741,25.236c-0.35,0.767-0.716,1.59-1.429,2.04 c-0.646,0.408-1.453,0.431-2.217,0.441c-7.449,0.1-16.042-1.534-22.337,3.052c-5.339,3.89-9.236,9.939-9.616,16.634 c-0.415,7.308,2.732,14.303,5.969,20.869c1.96,3.976,4.024,8.524,2.453,12.67c-0.482,1.273-1.281,2.398-1.893,3.614 c-6.786,13.466,11.04,26.718,14.329,38.799c2.496,9.168,4.992,18.335,7.488,27.503c1.115-5.855,1.43-11.861,0.935-17.801 c-0.682-8.178-2.892-16.25-2.599-24.451c0.211-5.903,1.574-11.724,4.292-16.982c2.61-5.051,7.37-7.279,10.928-11.703 c3.293,3.071,6.879,6.289,11.335,6.938c2.803,0.408,5.648-0.262,8.351-1.108c4.091-1.28,9.896-5.899,13.87-6.213 c3.956-0.313,5.339,3.846,7.959,6.046c7.282,6.113,19.678,7.807,28.405,4.156c-2.023,0.846,9.795,22.891,10.177,24.887 c2.246,11.732,3.605,23.635,4.061,35.572c0.942,0.69,2.004-0.716,2.308-1.844c2.148-7.952,2.813-16.218,4.199-24.337 c1.567-9.175,5.283-17.818,8.271-26.591C2398.958,841.424,2399.697,835.656,2399.804,829.605z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 224.7783 2196.8696)",
    style: {
      fill: "#91B3FA"
    },
    cx: 2764.245,
    cy: 827.103,
    rx: 201.371,
    ry: 201.371
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFFFFF"
    },
    cx: 2762.336,
    cy: 827.698,
    r: 183.148
  }), /*#__PURE__*/React.createElement("g", null, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "SVGID_00000019658530260844862760000000391147239464024498_",
    cx: 2763.385,
    cy: 829.134,
    r: 183.148
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000070833830940514110630000011366672815120066204_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000019658530260844862760000000391147239464024498_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000070833830940514110630000011366672815120066204_)"
    }
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000069361594957209087580000012911932017707146429_",
    gradientUnits: "userSpaceOnUse",
    x1: 2769.2339,
    y1: 671.066,
    x2: 2749.219,
    y2: 994.3814
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000069361594957209087580000012911932017707146429_)"
    },
    d: "M2723.065,787.913 c-11.595,0-23.622,1.478-28.161-12.489c-8.546-26.305,5.81-65.63,29.351-79.95c7.875-4.79,17.055-6.886,26.092-8.7 c10.628-2.133,19.81-2.665,29.393,2.49c8.84,4.755,17.424-2.889,26.588,3.216c7.789,5.188,13.76,13.359,17.923,21.615 c5.436,10.781,8.26,22.668,10.63,34.507c0.537,2.681,1.052,5.459,0.453,8.127c-0.502,2.236-1.751,4.222-2.994,6.148 c-9.505,14.722-22.157,25.037-40.454,25.038C2791.884,787.913,2723.37,787.913,2723.065,787.913z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000022548572447925787450000000439840489538987444_",
    gradientUnits: "userSpaceOnUse",
    x1: 2699.2009,
    y1: 666.7307,
    x2: 2679.186,
    y2: 990.0446
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000022548572447925787450000000439840489538987444_)"
    },
    d: "M2720.737,741.612 c0,0,2.097,4.391-11.557,11.253c-7.614,3.826-22.425,9.481-24.379,25.999c-1.009,8.528-4.34,29.583-12.454,30.885 c-20.208,3.242-47.483,15.854-50.027,40.373c-2.92,28.142,5.176,42.915,19.502,46.594c10.523,2.703,13.19,5.531,11.061,16.654 c-2.041,10.668,6.051,48.946,23.704,58.699c39.559,21.854,74.017-77.719,74.017-77.719l8.096-128.558L2720.737,741.612z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000160908106375581181830000001885569028038326456_",
    gradientUnits: "userSpaceOnUse",
    x1: 2849.8811,
    y1: 676.0585,
    x2: 2829.8662,
    y2: 999.373
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000160908106375581181830000001885569028038326456_)"
    },
    d: "M2811.268,730.37 c0,0-2.135,4.652,11.766,11.922c7.751,4.053,22.83,10.045,24.82,27.545c1.027,9.035,3.432,21.73,11.692,23.11 c20.573,3.435,44.414,23.48,49.486,62.395c3.872,29.704-4.58,61.561-19.166,65.459c-10.713,2.864-9.907-2.814-7.74,8.97 c2.078,11.303-2.799,6.94-20.771,17.272c-40.273,23.153-80.492-54.852-80.492-54.852l-8.243-136.203L2811.268,730.37z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000150784498450705344430000007666982496909684377_",
    gradientUnits: "userSpaceOnUse",
    x1: 2710.7705,
    y1: 534.03,
    x2: 2731.04,
    y2: 666.9075
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF928E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FE7062"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000150784498450705344430000007666982496909684377_)"
    },
    d: "M2757.43,873.112 c0,0,30.571-7.878,37.064,1.862c3.246,16.195,4.916,32.285,4.916,32.285l-35.226,6.615l-23.295-5.363l-5.542-3.218 l-2.299-22.945C2733.048,882.348,2744.962,875.437,2757.43,873.112z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000057869850733425871980000018072831454824989058_",
    gradientUnits: "userSpaceOnUse",
    x1: 2717.325,
    y1: 787.8477,
    x2: 2769.9756,
    y2: 619.7361
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FEBBBA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000057869850733425871980000018072831454824989058_)"
    },
    d: "M2720.759,791.408 c0,0-4.916-14.747-12.289-9.832c-7.374,4.916,11.066,36.287,11.066,36.287L2720.759,791.408z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000158014288432124199260000003046714621386597523_",
    gradientUnits: "userSpaceOnUse",
    x1: 2795.0779,
    y1: 812.1989,
    x2: 2847.7283,
    y2: 644.0875
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FEBBBA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000158014288432124199260000003046714621386597523_)"
    },
    d: "M2794.494,791.408 c0,0,0-22.121,12.289-9.832c12.289,12.289-12.289,29.494-12.289,29.494V791.408z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000036213170848710083420000006438623307112162463_",
    gradientUnits: "userSpaceOnUse",
    x1: 2804.8999,
    y1: 519.6712,
    x2: 2825.1697,
    y2: 652.549
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF928E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FE7062"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000036213170848710083420000006438623307112162463_)"
    },
    d: "M2910.248,992.289 c-10.289-49.667-25.063-88.486-29.73-90.734l-27.903,69.033c0,0-5.634,20.571-5.179,46.112h42.913 C2903.215,1016.7,2912.858,1004.887,2910.248,992.289z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000171709044974650306270000008990648024229018796_",
    gradientUnits: "userSpaceOnUse",
    x1: 2604.2456,
    y1: 550.2797,
    x2: 2624.5151,
    y2: 683.158
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF928E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FE7062"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000171709044974650306270000008990648024229018796_)"
    },
    d: "M2695.457,1016.7 c1.286-22.186,0.724-36.16,0.724-36.16l-39.325-63.843c0,0-4.916,19.572-9.832,71.186c-0.229,2.399-0.446,4.839-0.654,7.314 c-0.972,11.575,8.178,21.503,19.794,21.503H2695.457z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000177453645209613752450000010502532419382977199_",
    gradientUnits: "userSpaceOnUse",
    x1: 2759.7849,
    y1: 962.1918,
    x2: 2784.0588,
    y2: 799.7449
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FEBBBA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000177453645209613752450000010502532419382977199_)"
    },
    d: "M2749.894,1016.839h42.82 l11.612-122.055c0,0-9.831-2.532-14.747-19.736c-4.916-17.205-7.374-51.651-7.374-51.651l-44.24,9.812 c0,0,4.916,46.837-4.916,68.957L2749.894,1016.839z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000009564650672053344600000014124025435696139660_",
    gradientUnits: "userSpaceOnUse",
    x1: 2748.032,
    y1: 997.3137,
    x2: 2759.7419,
    y2: 918.9485
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000009564650672053344600000014124025435696139660_)"
    },
    d: "M2815.823,1016.839l6.161-77.046 c-44.852,26.833-90.975,25.532-137.755,11.302l13.277,65.744H2815.823z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000088112794851272681140000011369519061544946869_",
    gradientUnits: "userSpaceOnUse",
    x1: 2644.1667,
    y1: 544.1902,
    x2: 2664.4363,
    y2: 677.0679
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF928E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FE7062"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000088112794851272681140000011369519061544946869_)"
    },
    d: "M2760.403,1016.7 c-13.291-64.107-27.355-134.275-27.355-134.275l-7.373,14.709l-68.819,19.721c3.37,15.725,13.657,59.005,24.002,99.846 H2760.403z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000105403080669339675190000017023907862357066172_",
    gradientUnits: "userSpaceOnUse",
    x1: 2762.3611,
    y1: 526.1599,
    x2: 2782.6306,
    y2: 659.0376
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF928E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FE7062"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000105403080669339675190000017023907862357066172_)"
    },
    d: "M2858.742,1016.7 c3.666-19.637,6.896-34.966,6.896-34.966l14.879-80.179c-4.682-4.682-78.159-14.759-78.159-14.759l-7.865-11.74 c0,0-9.811,71.324-18.198,141.643H2858.742z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000156575238445802708180000011890831178138698916_",
    gradientUnits: "userSpaceOnUse",
    x1: 2752.9556,
    y1: 799.0067,
    x2: 2805.6062,
    y2: 630.8947
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FEBBBA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000156575238445802708180000011890831178138698916_)"
    },
    d: "M2715.844,756.999 c0,0-2.458,58.988,4.916,68.819c7.374,9.831,17.205,31.952,34.409,34.41c17.205,2.458,44.241-46.699,44.241-49.156 c0-2.458-2.458-66.361-2.458-66.361S2745.337,702.927,2715.844,756.999z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000060753551073271941100000017880025007411539332_",
    gradientUnits: "userSpaceOnUse",
    x1: 2699.1624,
    y1: 662.939,
    x2: 2912.2668,
    y2: 1002.6185
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000060753551073271941100000017880025007411539332_)"
    },
    d: "M2706.012,747.167 c0,0-9.831,29.494,19.663,19.663c29.494-9.831,29.494-9.831,29.494-9.831s29.494-17.205,34.41-9.831 c4.915,7.373,9.831,25.532,9.831,25.532s9.831-25.532,0-40.279C2789.579,717.673,2728.133,705.385,2706.012,747.167z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#91B3FA"
    },
    cx: 2419.626,
    cy: 1427.593,
    r: 227.54
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFFFFF"
    },
    cx: 2417.468,
    cy: 1428.265,
    r: 206.949
  }), /*#__PURE__*/React.createElement("g", null, _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "SVGID_00000023248345840212190630000009348290658735050665_",
    cx: 2418.653,
    cy: 1429.888,
    r: 206.949
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000009557226256422728370000007560406484223267761_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000023248345840212190630000009348290658735050665_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000009557226256422728370000007560406484223267761_)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000047781863778719792340000007329195321475977613_",
    gradientUnits: "userSpaceOnUse",
    x1: 2444.1128,
    y1: 1259.1533,
    x2: 2354.699,
    y2: 1600.3862
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "url(#SVGID_00000047781863778719792340000007329195321475977613_)"
    },
    cx: 2423.178,
    cy: 1339.047,
    r: 67.498
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000173873373873392154160000017678907647582971570_",
    gradientUnits: "userSpaceOnUse",
    x1: 2423.2578,
    y1: 1253.6887,
    x2: 2333.844,
    y2: 1594.9209
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000173873373873392154160000017678907647582971570_)"
    },
    d: "M2358.351,1320.2 c-29.688,102.662-49.873,195.991-46.596,222.234l86.552-9.138l10.036-189.893L2358.351,1320.2z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000106133073238960453090000011638961631322445714_",
    gradientUnits: "userSpaceOnUse",
    x1: 2541.0015,
    y1: 1284.5413,
    x2: 2451.5874,
    y2: 1625.7745
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000106133073238960453090000011638961631322445714_)"
    },
    d: "M2454.163,1309.599l-11.879,232.123 l97.935,52.152c-2.052-79.328-42.58-283.163-59.168-288.629L2454.163,1309.599z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000034082802732142667370000001108695449910447037_",
    gradientUnits: "userSpaceOnUse",
    x1: -3842.4919,
    y1: 2098.0913,
    x2: -3874.1228,
    y2: 2325.5894,
    gradientTransform: "matrix(-0.9716 0.2367 0.2367 0.9716 -1851.795 224.4752)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FEBBBA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000034082802732142667370000001108695449910447037_)"
    },
    points: "2454.183,1435.307  2457.034,1498.525 2395.72,1507.756 2391.856,1441.393  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000016769414240898085970000010140943157306455998_",
    gradientUnits: "userSpaceOnUse",
    x1: 2403.6123,
    y1: 1492.0422,
    x2: 2462.0137,
    y2: 1167.1837
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FEBBBA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000016769414240898085970000010140943157306455998_)"
    },
    d: "M2483.265,1397.237 c0,0-14.695,65.631-54.455,73.517c-39.761,7.886-51.54-53.952-53.637-58.398c0,0-8.892,4.195-10.888-4.647 c-1.997-8.841-12.483-31.07,7.297-30.617c0,0-3.893-22.078,2.951-32.916c6.845-10.838,20.634-36.91,49.054-29.663 C2452.008,1321.759,2497.437,1345.675,2483.265,1397.237z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000060715113980806267520000012756001592570417072_",
    gradientUnits: "userSpaceOnUse",
    x1: -3038.2129,
    y1: 1346.5579,
    x2: -3069.844,
    y2: 1574.058,
    gradientTransform: "matrix(-1 0 0 1 -636.607 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FEBBBA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000060715113980806267520000012756001592570417072_)"
    },
    d: "M2456.081,1477.391l38.884,20.62 l-50.924,55.877l-94.144-59.216c14.34-5.355,28.441-12.549,41.323-14.69L2456.081,1477.391z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000034768685233921304210000008252727365745525149_",
    gradientUnits: "userSpaceOnUse",
    x1: 1986.0144,
    y1: 991.066,
    x2: 2278.8757,
    y2: 1407.0939,
    gradientTransform: "matrix(0.9959 0.0909 -0.0909 0.9959 456.6098 49.6852)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000034768685233921304210000008252727365745525149_)"
    },
    d: "M2373.807,1318.38 c-13.287,18.585-2.84,35.072-6.408,48.415c12.87-4.678,56.335-11.671,69.416-10.387c2.706-8.89-2.604-23.682-5.326-35.344 c4.247,11.073,13.948,28.022,12.916,36.769c17.569,0.808,13.97,1.051,33.716,8.962l-15.373-53.604 C2428.517,1297.198,2398.95,1299.235,2373.807,1318.38z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000168833343053034810680000016703815274705741982_",
    gradientUnits: "userSpaceOnUse",
    x1: 2396.623,
    y1: 1217.2328,
    x2: 2502.365,
    y2: 1401.0612
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000168833343053034810680000016703815274705741982_)"
    },
    d: "M2439.243,1255.376 c0,12.889-12.129,27.354-20.871,27.354c-7.2,0-20.871-14.465-20.871-27.354s9.344-23.337,20.871-23.337 S2439.243,1242.487,2439.243,1255.376z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000146490517876684661320000011575768971441565060_",
    gradientUnits: "userSpaceOnUse",
    x1: 2424.3687,
    y1: 1116.5747,
    x2: 2424.3687,
    y2: 1335.0342
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF928E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FE7062"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000146490517876684661320000011575768971441565060_)"
    },
    d: "M2522.867,1637.912l21.407-119.083 c-29.121-19.811-56.118-29.24-88.193-41.396c-9.944,20.673-55.363,18.625-64.861,2.569 c-30.206,7.668-58.96,21.851-86.757,40.215l29.295,117.695H2522.867z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000032633928809946504640000016602279473737978519_",
    gradientUnits: "userSpaceOnUse",
    x1: 2547.1443,
    y1: 1116.5743,
    x2: 2547.1443,
    y2: 1335.0349
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF928E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FE7062"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000032633928809946504640000016602279473737978519_)"
    },
    d: "M2581.587,1616.852 c-17.338-74.141-37.313-98.023-37.313-98.023l-32.03,97.472c0,0,3.857,7.777,8.929,21.611h43.686 C2575.913,1637.912,2584.104,1627.615,2581.587,1616.852z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000008139355974727472340000009990219246022068400_",
    gradientUnits: "userSpaceOnUse",
    x1: 2312.2646,
    y1: 1116.5741,
    x2: 2312.2646,
    y2: 1335.0337
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF928E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FE7062"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000008139355974727472340000009990219246022068400_)"
    },
    d: "M2335.882,1637.912 c3.543-12.727,8.272-26.091,14.413-39.781l-45.831-77.883c0,0-22.606,39.268-30.09,98.413 c-1.293,10.223,6.717,19.251,17.021,19.251H2335.882z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000165915869919313542080000003871329461799168134_",
    gradientUnits: "userSpaceOnUse",
    x1: 2321.1978,
    y1: 1238.6771,
    x2: 2614.0745,
    y2: 1654.7266
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000165915869919313542080000003871329461799168134_)"
    },
    d: "M2460.736,1314.385 c22.711,57.422,34.055,219.378,20.18,305.033c21.714-74.769,48.759-169.611,7.434-297.14L2460.736,1314.385z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#91B3FA"
    },
    cx: 2896.083,
    cy: 1258.052,
    r: 204.695
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -42.3299 2415.1189)",
    style: {
      fill: "#FFFFFF"
    },
    cx: 2894.142,
    cy: 1258.656,
    rx: 186.171,
    ry: 186.171
  }), /*#__PURE__*/React.createElement("g", null, _defs4 || (_defs4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("ellipse", {
    id: "SVGID_00000050665131435752666150000017954220094543117741_",
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -43.0497 2416.3003)",
    cx: 2895.208,
    cy: 1260.116,
    rx: 186.171,
    ry: 186.171
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000005233964160746216000000000654431952572985248_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000050665131435752666150000017954220094543117741_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000005233964160746216000000000654431952572985248_)"
    }
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000044865721539538178620000003089623718494581141_",
    gradientUnits: "userSpaceOnUse",
    x1: 3002.6631,
    y1: 1396.5808,
    x2: 3037.8633,
    y2: 1396.5808
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4F52FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4042E2"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000044865721539538178620000003089623718494581141_)"
    },
    d: "M3019.16,1465.362 c10.378,0,18.772-8.454,18.703-18.833c-0.199-29.726-0.803-55.844-2.189-70.259c-3.538-36.798-23.063-48.471-23.063-48.471 l-9.948,137.563H3019.16z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000072248289879609782410000008546393756994192573_",
    gradientUnits: "userSpaceOnUse",
    x1: 3475.9731,
    y1: 224.7387,
    x2: 3283.4224,
    y2: 604.7735
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF928E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FE7062"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000072248289879609782410000008546393756994192573_)"
    },
    d: "M2971.122,1465.362 c-1.452-77.063-2.879-140.794-2.879-140.794c-34.894-21.474-163.735-18.776-163.735-18.776s-8.946,74.341-19.148,159.57 H2971.122z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000088825399094492182350000007344248337670697113_",
    gradientUnits: "userSpaceOnUse",
    x1: 2747.2581,
    y1: 1377.8192,
    x2: 2878.2444,
    y2: 1377.8192
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4F52FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4042E2"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000088825399094492182350000007344248337670697113_)"
    },
    d: "M2758.342,1465.362h119.903 c-3.854-37.256-34.816-175.086-34.816-175.086l-96.171,29.432c0,0,7.594,85.935,7.594,112.776 C2754.852,1438.632,2756.577,1450.562,2758.342,1465.362z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000150782877039126681770000005894545029099187596_",
    gradientUnits: "userSpaceOnUse",
    x1: 2694.2908,
    y1: 1392.5879,
    x2: 2762.03,
    y2: 1392.5879
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4F52FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4042E2"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000150782877039126681770000005894545029099187596_)"
    },
    d: "M2761.95,1465.362 c0.427-45.421-0.385-129.198-14.692-145.549c0,0-18.529,9.536-37.318,71.272c-5.422,17.817-10.349,34.73-14.936,50.843 c-3.345,11.75,5.487,23.435,17.704,23.435H2761.95z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000094586904815814946320000001819905689896148927_",
    gradientUnits: "userSpaceOnUse",
    x1: 2890.959,
    y1: 1383.2491,
    x2: 3013.7551,
    y2: 1383.2491
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4F52FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4042E2"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000094586904815814946320000001819905689896148927_)"
    },
    d: "M3008.997,1465.362 c3.461-65.325,6.483-134.931,3.614-137.801c-5.368-5.369-69.868-26.426-69.868-26.426s-42.023,128.502-51.784,164.227H3008.997 z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000092455855166730052970000004508522834824624020_",
    gradientUnits: "userSpaceOnUse",
    x1: 2931.8997,
    y1: 1119.3727,
    x2: 2865.2124,
    y2: 1427.1606
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FEBBBA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000092455855166730052970000004508522834824624020_)"
    },
    d: "M2847.455,1313.07l16.105-56.368 h59.052l8.052,64.42C2930.664,1321.123,2879.665,1334.544,2847.455,1313.07z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000170985431308035384500000016346573175177344130_",
    gradientUnits: "userSpaceOnUse",
    x1: 2891.8289,
    y1: 1218.6841,
    x2: 2934.5706,
    y2: 1014.3779
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FEBBBA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000170985431308035384500000016346573175177344130_)"
    },
    d: "M2847.455,1183.484 c0,0,5.55,53.921,14.908,74.977c9.358,21.056,32.754,21.056,35.094,21.056c2.34,0,23.396-4.679,35.094-23.396 c11.698-18.717,16.377-79.546,16.377-79.546s-21.056-23.396-49.131-25.735 C2871.721,1148.502,2847.455,1171.786,2847.455,1183.484z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000103248719986906424110000015129894676139861908_",
    gradientUnits: "userSpaceOnUse",
    x1: 2941.3613,
    y1: 1229.0466,
    x2: 2984.103,
    y2: 1024.7405
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FEBBBA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000103248719986906424110000015129894676139861908_)"
    },
    d: "M2938.717,1203.019 c0,0,10.737-16.105,16.105-10.737c5.368,5.369-5.368,40.263-16.105,40.263 C2927.98,1232.545,2938.717,1203.019,2938.717,1203.019z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000106135558958522161690000010876225613778763170_",
    gradientUnits: "userSpaceOnUse",
    x1: 2849.0742,
    y1: 1209.7397,
    x2: 2891.8162,
    y2: 1005.4333
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FEBBBA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000106135558958522161690000010876225613778763170_)"
    },
    d: "M2858.192,1205.703 c0,0-13.421-18.789-18.789-13.421c-5.369,5.369,8.052,40.263,18.789,40.263V1205.703z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000026860220277194384080000012382893253575313051_",
    gradientUnits: "userSpaceOnUse",
    x1: 2897.0481,
    y1: 1121.4518,
    x2: 2916.9832,
    y2: 1275.657
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#090056"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#020039"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000026860220277194384080000012382893253575313051_)"
    },
    d: "M2966.265,1171.068 c2.834-7.383,3.577-15.61,2.656-23.509c-1.388-11.918-7.797-34.023-16.665-42.891c2.522,2.522-21.542,12.701-25.252,12.336 c7.232-5.893,16.236-12.632,16.562-22.912c-8.372,5.636-18.586,7.683-28.525,9.435c-24.803,4.371-51.453,3.457-70.535,22.222 c-7.972,7.84-13.375,19.945-11.331,31.253c1.492,8.254,13.782,16.958,6.221,24.551c-5.347,5.37,10.851,15.139,13.481,30.377 c0.189,1.097,0.381,2.232,0.701,3.271c-0.235-7.79-3.227-16.164-3.037-23.738c0.389-15.542,23.819-16.637,35.279-17.666 c15.253-1.37,31.876-1.237,45.074-10.148c5.367-3.624,8.772,25.662,9.002,27.098c1.33,8.329,2.91,17.268,1.506,25.693 l3.696-0.001c1.069-9.876,0.088-19.33,7.349-26.52c3.507-3.472,7.039-6.974,9.794-11.068 C2963.883,1176.412,2965.217,1173.798,2966.265,1171.068z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000133516896964432461640000008691493854766246793_",
    gradientUnits: "userSpaceOnUse",
    x1: 2841.3625,
    y1: 1287.1681,
    x2: 2830.0439,
    y2: 1467.1333
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4F52FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4042E2"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000133516896964432461640000008691493854766246793_)"
    },
    d: "M2860.696,1266.728 c-2.046,12.344-2.676,18.299-6.602,30.178c-3.544,10.722-0.937,25.663-0.724,36.933c0.298,15.737,12.528,32.952,9.847,48.425 c-6.848-19.244-27.752-34.215-38.453-52.182c-10.452-17.549-17.916-31.719-5.969-48.287 C2826.204,1271.52,2860.855,1265.768,2860.696,1266.728z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000070828493413368645790000014217212841640455825_",
    gradientUnits: "userSpaceOnUse",
    x1: 2939.7571,
    y1: 1296.0094,
    x2: 2928.7969,
    y2: 1470.276
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4F52FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4042E2"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000070828493413368645790000014217212841640455825_)"
    },
    d: "M2923.912,1318.333 c1.479,32.767-4.947,39.422-10.156,72.533c6.998-22.375,22.763-34.125,35.172-54.074c12.231-19.662,16.195-44.169-3.83-57.275 c-1.369-0.896-20.739-9.866-20.649-8.125C2924.693,1276.177,2923.271,1304.134,2923.912,1318.333z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000164495066407730852920000006195717562806338983_",
    gradientUnits: "userSpaceOnUse",
    x1: 2018.9108,
    y1: -513.5072,
    x2: 1826.3601,
    y2: -133.473
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF928E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FE7062"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "url(#SVGID_00000164495066407730852920000006195717562806338983_)"
    },
    cx: 1047.691,
    cy: 1403.376,
    r: 140.367
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000004543557024419098100000016996162195239004832_",
    gradientUnits: "userSpaceOnUse",
    x1: 2018.9109,
    y1: -513.5077,
    x2: 1826.361,
    y2: -133.4746
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF928E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FE7062"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "url(#SVGID_00000004543557024419098100000016996162195239004832_)"
    },
    cx: 1047.691,
    cy: 1403.376,
    r: 135.7
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.7,
      fill: "#FFFFFF"
    },
    d: "M922.599,1398.013c-0.023,0-0.045,0-0.068-0.001c-0.708-0.038-1.253-0.643-1.216-1.35 c0.278-5.325,0.897-10.673,1.838-15.896c0.127-0.698,0.791-1.162,1.493-1.036c0.699,0.127,1.162,0.794,1.037,1.493 c-0.923,5.117-1.529,10.357-1.802,15.573C923.845,1397.481,923.278,1398.013,922.599,1398.013z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.7,
      fill: "#FFFFFF"
    },
    d: "M935.793,1348.29c-0.195,0-0.392-0.044-0.578-0.138 c-0.634-0.32-0.888-1.093-0.568-1.725c21.671-42.932,64.986-69.602,113.044-69.602c7.667,0,15.347,0.691,22.829,2.054 c0.698,0.127,1.161,0.796,1.034,1.493c-0.127,0.699-0.79,1.168-1.494,1.034c-7.33-1.335-14.856-2.011-22.368-2.011 c-47.082,0-89.518,26.129-110.75,68.189C936.715,1348.032,936.263,1348.29,935.793,1348.29z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -686.6998 1154.8251)",
    style: {
      opacity: 0.78,
      fill: "#FFFFFF"
    },
    cx: 1050.647,
    cy: 1406.332,
    rx: 114.853,
    ry: 114.853
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000036217877019846550200000000289956949785942442_",
    gradientUnits: "userSpaceOnUse",
    x1: 2005.2421,
    y1: -520.4293,
    x2: 1812.6918,
    y2: -140.3956
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF928E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FE7062"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000036217877019846550200000000289956949785942442_)"
    },
    d: "M1085.811,1362.933 c0,19.448-15.765,40.443-35.213,40.443c-19.448,0-35.213-20.995-35.213-40.443c0-19.448,15.765-33.245,35.213-33.245 C1070.046,1329.689,1085.811,1343.486,1085.811,1362.933z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000003803067265113093010000015049357395696214170_",
    gradientUnits: "userSpaceOnUse",
    x1: 2038.3707,
    y1: -503.6452,
    x2: 1845.8204,
    y2: -123.6116
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF928E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FE7062"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000003803067265113093010000015049357395696214170_)"
    },
    d: "M1006.899,1478.25h85.961 c9.049,0,17.06-5.848,19.818-14.467l4.626-14.457c3.387-10.586-2.12-22.046-12.558-25.863 c-34.983-12.791-71.156-11.15-108.212,1.18c-10.381,3.454-16.142,14.558-13.277,25.117l3.562,13.13 C989.277,1471.957,997.506,1478.25,1006.899,1478.25z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000050634526949765060280000000315417465856418199_",
    gradientUnits: "userSpaceOnUse",
    x1: 2132.5056,
    y1: -455.9511,
    x2: 1939.9552,
    y2: -75.9169
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF928E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FE7062"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "url(#SVGID_00000050634526949765060280000000315417465856418199_)"
    },
    cx: 1300.945,
    cy: 1185.287,
    r: 140.367
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000092443898638157651690000011944111333437053610_",
    gradientUnits: "userSpaceOnUse",
    x1: 2132.5059,
    y1: -455.9516,
    x2: 1939.9559,
    y2: -75.9186
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF928E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FE7062"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "url(#SVGID_00000092443898638157651690000011944111333437053610_)"
    },
    cx: 1300.945,
    cy: 1185.287,
    r: 135.7
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.7,
      fill: "#FFFFFF"
    },
    d: "M1175.854,1179.925c-0.022,0-0.045,0-0.068-0.001 c-0.708-0.038-1.253-0.643-1.216-1.35c0.278-5.325,0.896-10.673,1.838-15.896c0.127-0.698,0.791-1.162,1.492-1.036 c0.699,0.127,1.163,0.794,1.037,1.493c-0.923,5.117-1.529,10.357-1.802,15.573 C1177.1,1179.392,1176.533,1179.925,1175.854,1179.925z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.7,
      fill: "#FFFFFF"
    },
    d: "M1189.048,1130.202c-0.194,0-0.392-0.044-0.578-0.138 c-0.634-0.32-0.888-1.093-0.568-1.725c21.671-42.932,64.986-69.602,113.044-69.602c7.667,0,15.347,0.691,22.829,2.054 c0.698,0.127,1.161,0.796,1.034,1.493c-0.127,0.699-0.79,1.168-1.495,1.034c-7.33-1.335-14.855-2.011-22.368-2.011 c-47.082,0-89.518,26.129-110.75,68.189C1189.97,1129.943,1189.517,1130.202,1189.048,1130.202z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -458.3112 1270.0266)",
    style: {
      opacity: 0.78,
      fill: "#FFFFFF"
    },
    cx: 1303.902,
    cy: 1188.244,
    rx: 114.853,
    ry: 114.853
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000111186439110078663840000002066472457066128029_",
    gradientUnits: "userSpaceOnUse",
    x1: 2118.8391,
    y1: -462.8773,
    x2: 1926.2887,
    y2: -82.8435
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF928E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FE7062"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000111186439110078663840000002066472457066128029_)"
    },
    d: "M1339.066,1144.845 c0,19.448-15.765,40.443-35.213,40.443c-19.448,0-35.213-20.995-35.213-40.443c0-19.448,15.765-33.245,35.213-33.245 C1323.301,1111.6,1339.066,1125.397,1339.066,1144.845z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000152255597044887842600000017215327205143336115_",
    gradientUnits: "userSpaceOnUse",
    x1: 2151.9656,
    y1: -446.0888,
    x2: 1959.4154,
    y2: -66.0553
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF928E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FE7062"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000152255597044887842600000017215327205143336115_)"
    },
    d: "M1260.154,1260.162h85.961 c9.049,0,17.06-5.848,19.817-14.467l4.626-14.457c3.387-10.586-2.12-22.046-12.558-25.863 c-34.983-12.791-71.156-11.15-108.212,1.18c-10.381,3.454-16.142,14.558-13.277,25.117l3.562,13.13 C1242.532,1253.868,1250.761,1260.162,1260.154,1260.162z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000008133854512892174650000017008709020582312090_",
    gradientUnits: "userSpaceOnUse",
    x1: 2304.5374,
    y1: -368.6911,
    x2: 2111.9868,
    y2: 11.3431
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF928E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FE7062"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "url(#SVGID_00000008133854512892174650000017008709020582312090_)"
    },
    cx: 1352.718,
    cy: 1509.901,
    r: 140.367
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000024691300518114010400000015799014167589316271_",
    gradientUnits: "userSpaceOnUse",
    x1: 2304.5762,
    y1: -368.7681,
    x2: 2112.0264,
    y2: 11.2649
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF928E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FE7062"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "url(#SVGID_00000024691300518114010400000015799014167589316271_)"
    },
    cx: 1352.718,
    cy: 1509.901,
    r: 135.7
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.7,
      fill: "#FFFFFF"
    },
    d: "M1227.626,1504.538c-0.023,0-0.045,0-0.068-0.001 c-0.708-0.038-1.253-0.642-1.216-1.35c0.278-5.325,0.897-10.673,1.838-15.896c0.127-0.698,0.791-1.162,1.493-1.036 c0.699,0.127,1.162,0.794,1.037,1.493c-0.923,5.117-1.529,10.357-1.802,15.573 C1228.872,1504.006,1228.305,1504.538,1227.626,1504.538z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.7,
      fill: "#FFFFFF"
    },
    d: "M1240.82,1454.815c-0.194,0-0.392-0.044-0.578-0.138 c-0.634-0.32-0.888-1.093-0.568-1.725c21.671-42.932,64.986-69.602,113.044-69.602c7.667,0,15.347,0.691,22.829,2.054 c0.698,0.127,1.161,0.796,1.034,1.493c-0.127,0.699-0.79,1.168-1.494,1.034c-7.33-1.335-14.856-2.011-22.368-2.011 c-47.082,0-89.519,26.129-110.75,68.189C1241.742,1454.557,1241.29,1454.815,1240.82,1454.815z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      opacity: 0.78,
      fill: "#FFFFFF"
    },
    cx: 1355.674,
    cy: 1512.858,
    r: 114.853
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000119825227719694527090000004332627443640708795_",
    gradientUnits: "userSpaceOnUse",
    x1: 2290.9102,
    y1: -375.6952,
    x2: 2098.3599,
    y2: 4.3385
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF928E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FE7062"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000119825227719694527090000004332627443640708795_)"
    },
    d: "M1390.839,1469.458 c0,19.448-15.765,40.443-35.213,40.443c-19.448,0-35.213-20.995-35.213-40.443c0-19.447,15.765-33.245,35.213-33.245 C1375.073,1436.214,1390.839,1450.011,1390.839,1469.458z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000177483438179604972420000001759123537253298107_",
    gradientUnits: "userSpaceOnUse",
    x1: 2324.0376,
    y1: -358.9086,
    x2: 2131.4873,
    y2: 21.1249
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF928E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FE7062"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000177483438179604972420000001759123537253298107_)"
    },
    d: "M1311.926,1584.776h85.961 c9.049,0,17.06-5.848,19.817-14.467l4.626-14.457c3.387-10.585-2.12-22.046-12.558-25.863 c-34.983-12.791-71.156-11.15-108.212,1.18c-10.381,3.454-16.142,14.558-13.277,25.117l3.562,13.13 C1294.304,1578.482,1302.533,1584.776,1311.926,1584.776z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000163048816679800780910000010430214276244668075_",
    gradientUnits: "userSpaceOnUse",
    x1: -2817.8789,
    y1: 1349.1102,
    x2: -2702.8513,
    y2: 1637.6547,
    gradientTransform: "matrix(-1 0 0 1 -1165.4333 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000163048816679800780910000010430214276244668075_)"
    },
    d: "M1584.241,1504.324 c0,0-38.779,18.862-45.909,40.53c-5.721,17.386-48.6,19.627-52.836,53.82c-2.187,17.654-15.251,31.792-32.834,34.487 c-43.793,6.712-111.284,29.453-122.082,105.489c-8.242,58.037,21.344,80.044,52.394,87.661 c22.805,5.595,37.961,27.777,33.348,50.801c-4.424,22.084,2.174,47.613,40.432,67.801 c85.734,45.239,171.353-107.175,171.353-107.175l17.547-266.124L1584.241,1504.324z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000172432249662285664660000017775211006124380068_",
    gradientUnits: "userSpaceOnUse",
    x1: -3128.5352,
    y1: 1047.1248,
    x2: -2916.0313,
    y2: 1530.6188,
    gradientTransform: "matrix(-0.9776 -0.2106 -0.2106 0.9776 -915.0133 -113.5247)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FEBBBA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000172432249662285664660000017775211006124380068_)"
    },
    d: "M2050.746,1441.234 c0,0-171.18,270.759-374.734,323.057c0,0,39.663,112.968,70.277,125.897c0,0,250.428-208.954,314.784-410.479L2050.746,1441.234z "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000087407352114801363650000007467808194756655037_",
    gradientUnits: "userSpaceOnUse",
    x1: -2397.3872,
    y1: 3196.4016,
    x2: -2299.8481,
    y2: 3196.4016,
    gradientTransform: "matrix(-1 0 0 1 -1165.4333 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000087407352114801363650000007467808194756655037_)"
    },
    d: "M1231.838,3173.009l-5.548,45.608 c-1.053,8.652-7.865,15.494-16.524,16.483c-14.621,1.67-38.084,3.382-61.04,0.955c-10.076-1.065-16.618-11.268-13.548-20.925 c5.596-17.607,15.834-44.037,30.595-59.59h50.594C1225.72,3155.541,1232.967,3163.723,1231.838,3173.009z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000157282287912727204250000002290568985398396094_",
    gradientUnits: "userSpaceOnUse",
    x1: -2809.5398,
    y1: 3581.042,
    x2: -2669.1741,
    y2: 1940.5168,
    gradientTransform: "matrix(-1 0 0 1 -1165.4333 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FEBBBA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000157282287912727204250000002290568985398396094_)"
    },
    d: "M1628.108,2638.734l8.54,50.233 c0,0-28.597,289.664-33.684,405.53c-0.797,18.166,3.902,36.117,13.436,51.6l49.725,80.749l-126.376-74.573l-2.516-15.422 l20.688-28.445l-27.098-324.496c-1.592-19.063,2.342-38.18,11.33-55.066l26.14-49.107L1628.108,2638.734z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000020378771296624149600000017644672310222500757_",
    gradientUnits: "userSpaceOnUse",
    x1: -2850.5449,
    y1: 3178.5935,
    x2: -2692.7192,
    y2: 3178.5935,
    gradientTransform: "matrix(-1 0 0 1 -1165.4333 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000020378771296624149600000017644672310222500757_)"
    },
    d: "M1674.447,3238.544h-40.329 c-7.549,0-14.668-3.466-19.272-9.448c-12.573-16.336-38.621-48.209-51.076-49.041c-16.767-1.12-14.622,58.489-14.622,58.489 h-9.399l-11.905-74.071c-2.995-18.637,6.273-37.099,23.008-45.831c0,0,3.833,28.345,24.616,40.884 c20.783,12.538,84.572,57.439,84.572,57.439s7.813-1.114,16.391,0.436C1689.156,3219.701,1687.378,3238.544,1674.447,3238.544z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000003810255911704251400000010366974570302270108_",
    gradientUnits: "userSpaceOnUse",
    x1: -2527.1855,
    y1: 3605.4521,
    x2: -2386.783,
    y2: 1964.4956,
    gradientTransform: "matrix(-1 0 0 1 -1165.4333 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FEBBBA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000003810255911704251400000010366974570302270108_)"
    },
    d: "M1455.014,2662.593 c0,0-167.53,317.788-194.161,390.345c-26.631,72.556-35.96,133.084-36.317,138.816c-0.558,8.956-11.698,17.547-42.404,17.547 c-15.847,0-23.608-6.353-27.408-12.501c-3.242-5.246-3.41-11.81-0.678-17.338c9.691-19.612,40.444-82.288,51.834-110.715 c13.599-33.94,42.85-187.752,58.893-241.23c16.042-53.478,34.176-111.489,104.037-164.924 C1368.809,2662.593,1416.767,2615.622,1455.014,2662.593z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000031886497512342594660000013832428348184937912_",
    gradientUnits: "userSpaceOnUse",
    x1: 2991.4028,
    y1: -9504.126,
    x2: 2798.8525,
    y2: -9124.0928,
    gradientTransform: "matrix(-1 0 0 1 -1165.4333 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF928E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FE7062"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000031886497512342594660000013832428348184937912_)"
    },
    d: "M1560.845,2141.88 c43.215-183.12-66.262-286.691-66.262-286.691c69.078-66.307,194.937-96.479,194.937-96.479s120.097,87.802,105.85,156.526 c-8.35,40.28-84.417,241.266-84.417,241.266S1640.616,2189.791,1560.845,2141.88z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000034052072786391991400000013608623103129626259_",
    gradientUnits: "userSpaceOnUse",
    x1: -2419.4534,
    y1: 1958.6416,
    x2: -2770.3867,
    y2: 2520.1345,
    gradientTransform: "matrix(-1 0 0 1 -1165.4333 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4F52FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4042E2"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000034052072786391991400000013608623103129626259_)"
    },
    d: "M1465.031,2232.538 c17.587-52.983,95.814-90.658,95.814-90.658c79.771,47.911,150.109,14.622,150.109,14.622s15.774,60.294,4.887,116.326 c-10.887,56.033-79.193,416.138-79.193,416.138c-107.628,21.808-273.157-21.941-273.157-21.941 C1432.045,2545.313,1447.444,2285.521,1465.031,2232.538z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000149358288894251058270000013155716346578745015_",
    gradientUnits: "userSpaceOnUse",
    x1: -2824.9333,
    y1: 1963.9753,
    x2: -2798.5659,
    y2: 1771.0791,
    gradientTransform: "matrix(-1 0 0 1 -1165.4333 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FEBBBA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000149358288894251058270000013155716346578745015_)"
    },
    d: "M1611.007,1637.698l-35.135,157.819 c-3.364,13.901,9.308,11.626,23.363,8.976c23.016-4.339,52.68-13.276,62.597-31.186c1.009-1.823,1.513-3.883,1.798-5.947 l15.095-109.435c1.198-8.682-3.496-17.109-11.508-20.661l-29.128-12.916C1626.874,1619.375,1613.893,1625.774,1611.007,1637.698z "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000157987396916179668090000008663751051846366630_",
    gradientUnits: "userSpaceOnUse",
    x1: -2948.3057,
    y1: 1282.5538,
    x2: -2718.2405,
    y2: 873.115,
    gradientTransform: "matrix(-0.9809 -0.1943 -0.1943 0.9809 -936.3432 -99.2406)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FEBBBA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000157987396916179668090000008663751051846366630_)"
    },
    d: "M1678.304,1493.83 c0,0,37.405,25.32,53.478,89.801c16.073,64.481-10.047,87.61-36.822,86.193c-26.775-1.417-65.596-9.697-99.232-55.956 C1562.092,1567.609,1629.288,1462.891,1678.304,1493.83z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000023281816249134689180000012921424677196783492_",
    gradientUnits: "userSpaceOnUse",
    x1: -2898.8281,
    y1: 925.9978,
    x2: -2783.7957,
    y2: 1214.5541,
    gradientTransform: "matrix(-0.9809 -0.1943 -0.1943 0.9809 -936.3432 -99.2406)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000023281816249134689180000012921424677196783492_)"
    },
    d: "M1629.648,1587.86 c0,0-13.705-92.396,63.006-78.263l15.511,16.149c0,0,37.548-42.286-4.004-74.25c-41.552-31.964-99.214-23.779-131.116,34.413 c-31.901,58.192-43.48,99.083-16.74,135.243c26.739,36.16,46.852,5.147,46.852,5.147s-12.263-31.296-2.088-44.726 c10.175-13.43,23.303,7.81,23.303,7.81L1629.648,1587.86z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000066501272838811104850000013625705980339905426_",
    gradientUnits: "userSpaceOnUse",
    x1: -2899.3345,
    y1: 1310.0745,
    x2: -2669.2693,
    y2: 900.6357,
    gradientTransform: "matrix(-0.9809 -0.1943 -0.1943 0.9809 -936.3432 -99.2406)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FEBBBA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000066501272838811104850000013625705980339905426_)"
    },
    d: "M1619.164,1595.773 c0,0-6.767-47.537-31.044-33.948c-24.278,13.589,8.75,44.406,21.992,54.891L1619.164,1595.773z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000008141739100369483610000016921145716820681357_",
    gradientUnits: "userSpaceOnUse",
    x1: -3170.5298,
    y1: 1065.5826,
    x2: -2958.0259,
    y2: 1549.0769,
    gradientTransform: "matrix(-0.9776 -0.2106 -0.2106 0.9776 -915.0133 -113.5247)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FEBBBA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000008141739100369483610000016921145716820681357_)"
    },
    d: "M2049.57,1496.975 c0.519,5.585-20.251,9.445-26.861-14.365c1.817-10.338,5.044-55.606,12.97-62.639c42.214-37.457,117.491-79.593,117.491-79.593 c8.419,12.853-2.622,21.319-2.622,21.319l-37.576,25.359c3.92,12.983,9.64,24.461,10.287,39.283 c0.49,11.224-3.656,22.214-11.107,30.728c-7.478,8.545-17.545,19.577-26.621,27.954 C2068.354,1500.874,2049.57,1496.975,2049.57,1496.975z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000151515037733457874960000012957837437441207442_",
    gradientUnits: "userSpaceOnUse",
    x1: 2045.524,
    y1: 1439.8564,
    x2: 2102.7456,
    y2: 1439.8564
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FEBBBA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000151515037733457874960000012957837437441207442_)"
    },
    d: "M2069.981,1478.521l-5.743-2.363 c0.763-1.858,18.796-45.677,27.517-54.792c3.314-3.458,4.914-6.42,4.767-8.807c-0.074-1.292-0.714-2.568-1.928-3.868 l-30.405,16.261l-13.43,21.027l-5.234-3.347l14.3-22.397l35.615-19.042l1.608,1.308c3.602,2.945,5.464,6.108,5.677,9.677 c0.262,4.25-1.854,8.66-6.473,13.488C2089.679,1432.528,2075.059,1466.145,2069.981,1478.521z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000102535498431162453350000004757373439801271214_",
    gradientUnits: "userSpaceOnUse",
    x1: -4032.3384,
    y1: 2013.496,
    x2: -4285.2163,
    y2: 2082.8032,
    gradientTransform: "matrix(-0.9988 -0.0494 -0.0494 0.9988 -2381.2668 -55.0328)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000102535498431162453350000004757373439801271214_)"
    },
    d: "M1600.002,2238.488 c0.24,0.012,0.48,0.018,0.722,0.016l313.886-0.339c7.759-0.006,14.043-6.237,14.035-13.914 c-0.008-7.68-6.327-14.025-14.066-13.887l-313.886,0.339c-7.759,0.006-14.042,6.237-14.035,13.915 C1586.667,2232.055,1592.579,2238.124,1600.002,2238.488z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000072246274656711913460000016636728259714999194_",
    gradientUnits: "userSpaceOnUse",
    x1: -4312.4277,
    y1: 1993.8792,
    x2: -4490.8008,
    y2: 2182.4087,
    gradientTransform: "matrix(-1 0 0 1 -2422.7358 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000072246274656711913460000016636728259714999194_)"
    },
    d: "M2196.779,1956.509h-261.406 c-19.284,0-36.836,11.011-45.062,28.269l-120.848,253.544h324.858c12.427,0,23.593-7.513,28.16-18.948l93.712-234.617 C2221.608,1971.2,2211.511,1956.509,2196.779,1956.509z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.313 -0.9497 0.9497 0.313 -591.509 3367.7329)",
    style: {
      fill: "#91B3FA"
    },
    cx: 2032.22,
    cy: 2092.752,
    rx: 33.157,
    ry: 20.574
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000123429199838381309780000008007190546728409763_",
    gradientUnits: "userSpaceOnUse",
    x1: 1175.0919,
    y1: 2213.4675,
    x2: 1726.5386,
    y2: 1982.7766
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FEBBBA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000123429199838381309780000008007190546728409763_)"
    },
    d: "M1494.133,1855.567 c-42.828,43.218-97.166,234.779-70.207,266.775c23.738,37.249,104.562,87.952,181.526,88.02h113.554 c-47.715-50.697-80.569-63.557-119.701-28.105c-31.048-13.266-71.307-64.658-98.178-87.603 c-10.551-9.009-13.04-24.377-5.984-36.322c21.347-36.139,48.119-73.294,56.632-109.281 C1553.603,1906.878,1522.395,1858.611,1494.133,1855.567z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7D97F4"
    },
    d: "M2058.874,3251.531c-3.047-0.184-5.868-1.57-7.865-3.879 c-29.115-33.64-242.305-298.005-5.639-572.102c224.671-260.204,331.022-318.158,334.976-461.411 c0.461-16.729,22.604-22.401,31.114-7.99c63.593,107.698,169.194,362.229-102.452,554.927 c-299.654,212.566-258.357,417.781-238.753,475.506C2072.846,3244.213,2066.918,3252.017,2058.874,3251.531L2058.874,3251.531z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7D97F4"
    },
    d: "M2098.198,3253.903c-7.215-0.435-13.287-5.517-14.923-12.557 c-11.138-47.92-43.159-227.708,86.699-285.786c142.955-63.935,271.865,63.987,371.818-51.239 c5.259-6.063,15.184-1.871,14.421,6.12c-5.412,56.671-38.483,189.479-227.025,229.877 c-201.806,43.24-222.993,68.357-216.694,97.064C2114.436,3246.234,2107.243,3254.449,2098.198,3253.903L2098.198,3253.903z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91B3FA"
    },
    d: "M2384.139,2359.606c-1.697,10.735-4.265,20.878-7.479,30.999 c-3.143,10.104-6.893,20.009-11.061,29.737c-8.234,19.514-18.474,38.157-29.875,56.042 c-22.98,35.699-51.624,67.693-83.762,95.414c-16.032,13.785-33.312,26.647-50.468,38.384 c-16.702,11.442-32.653,24.038-47.825,37.521c-30.368,26.963-57.433,57.638-80.878,90.801 c-46.686,66.36-77.484,144.522-83.451,225.726c-3.115,40.519-0.104,81.54,8.45,121.518c8.494,40.035,23,78.772,41.073,115.814 c0.974,1.974,0.165,4.364-1.809,5.338c-1.896,0.937-4.193,0.198-5.234-1.609c-20.613-36.398-36.911-75.516-47.378-116.387 c-5.313-20.407-9.117-41.253-11.338-62.302c-2.092-21.053-2.796-42.3-1.715-63.485c1.948-42.401,10.706-84.451,24.863-124.479 c14.205-40.051,34.098-77.958,58.032-112.971c23.922-35.06,52.335-66.954,83.893-95.324 c15.814-14.158,32.467-27.409,49.98-39.505c17.16-11.64,33.398-23.375,48.994-36.516c31.146-25.984,59.522-55.412,83.36-88.353 c12.094-16.347,22.853-33.679,32.525-51.632c9.452-17.97,18.131-36.833,23.949-56.101l0.076-0.25 c0.58-1.924,2.611-3.012,4.535-2.431C2383.359,2356.087,2384.421,2357.837,2384.139,2359.606z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91B3FA"
    },
    d: "M2087.261,3221.659c0.491-1.802,0.174-3.418-0.009-5.091l-0.531-4.985l-0.867-9.98 c-0.489-6.658-0.846-13.325-1.055-19.999c-0.408-13.347-0.273-26.719,0.512-40.074c1.644-26.669,5.647-53.441,14.438-79.033 c8.686-25.411,22.874-50.139,44.878-67.253c10.97-8.413,23.58-14.765,36.862-18.509c13.263-3.853,27.079-5.316,40.711-5.145 c53.541,2.165,106.333,8.43,159.117,12.772c26.274,1.92,52.883,3.397,78.13-2.008c6.27-1.406,12.411-3.26,18.331-5.665 c5.846-2.546,11.562-5.445,16.829-9.088c10.617-7.168,19.72-16.56,27.713-26.824l0.025-0.031 c1.101-1.414,3.139-1.668,4.552-0.567c1.395,1.086,1.659,3.087,0.61,4.498c-8.068,10.834-17.454,20.994-28.718,28.959 c-5.586,4.039-11.694,7.319-17.958,10.197c-6.333,2.738-12.897,4.87-19.556,6.51c-26.868,6.022-54.054,4.663-80.606,3.036 c-26.639-1.769-53.031-4.698-79.466-6.961c-26.353-2.281-53-4.397-79.156-5.488c-12.892-0.277-25.811,0.998-38.1,4.453 c-12.317,3.354-23.902,9.075-34.078,16.726c-20.518,15.343-34.512,38.355-43.352,62.791c-8.955,24.564-13.404,50.764-15.5,77.019 c-1.016,13.15-1.393,26.364-1.231,39.574c0.086,6.605,0.317,13.21,0.681,19.807l0.676,9.883l0.434,4.929 c0.166,1.629,0.217,3.313,1.138,4.804c0.874,1.416,0.435,3.272-0.979,4.146c-1.416,0.874-3.272,0.436-4.147-0.979 c-0.454-0.736-0.553-1.593-0.345-2.367L2087.261,3221.659z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgService4);
export default __webpack_public_path__ + "static/media/service4.3628dd36f0f4e8f8fe51f87a3f835829.svg";
export { ForwardRef as ReactComponent };